import React from "react";

var indexRoutes = [
    { path: "/", name: "FrontPage", component: React.Fragment }
];

export default indexRoutes;
